import { IPriceLocalized } from 'shared/types/Price';

export const getWindowItemProductVariantRowPriceLength = (price: IPriceLocalized) => {
  const priceAmount = price?.amount;

  if (!priceAmount || typeof priceAmount !== 'number') {
    return 0;
  }

  const hasNoDecimals = priceAmount % 100 === 0;
  const priceLength = priceAmount.toString().length;

  const longCurrencyPrefix = ['HKD', 'KRW', 'TWD'];
  const isLongCurrencyPrefix = longCurrencyPrefix.includes(price?.currency);

  const priceTotalLength = hasNoDecimals ? priceLength - 2 : priceLength;

  return isLongCurrencyPrefix ? priceTotalLength + 2 : priceTotalLength;
};
